// extracted by mini-css-extract-plugin
export default {"container":"beta-message_container__U6lkg","icon":"beta-message_icon__ubUwd"};